module.exports = __webpack_public_path__ + "img/checkmark_s2.3e4fb8ed.svg";